import AddToCartEvent from "./AddtoCartEvent";
import AddToCartShop from "./AddToCartShop";

const AddToCartModal = ({
  product,
  onClose,
  eventDates,
  isShopMode = false,
}) => {
  const inferredShopMode = isShopMode || !eventDates?.eventDate;

  return inferredShopMode ? (
    <AddToCartShop product={product} onClose={onClose} />
  ) : (
    <AddToCartEvent
      product={product}
      onClose={onClose}
      eventDates={eventDates}
    />
  );
};
export default AddToCartModal;
